/*
 * © 2024 Snyk Limited
 *
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonApi = exports.ProblemJson = exports.ErrorFormats = exports.Classification = void 0;
var Classification;
(function (Classification) {
    Classification["UNEXPECTED"] = "UNEXPECTED";
    Classification["ACTIONABLE"] = "ACTIONABLE";
    Classification["UNSUPPORTED"] = "UNSUPPORTED";
})(Classification || (exports.Classification = Classification = {}));
var ErrorFormats;
(function (ErrorFormats) {
    ErrorFormats[ErrorFormats["JsonApi"] = 0] = "JsonApi";
    ErrorFormats[ErrorFormats["ProblemJson"] = 1] = "ProblemJson";
})(ErrorFormats || (exports.ErrorFormats = ErrorFormats = {}));
class ProblemJson {
    constructor(payload) {
        this.payload = payload;
    }
    headers() {
        return {
            'Content-Type': 'application/problem+json;',
        };
    }
    body() {
        return this.payload;
    }
}
exports.ProblemJson = ProblemJson;
class JsonApi {
    constructor(payload) {
        this.payload = payload;
    }
    headers() {
        return {};
    }
    body() {
        return this.payload;
    }
}
exports.JsonApi = JsonApi;
//# sourceMappingURL=types.js.map